import { render, staticRenderFns } from "./CorrelationSection.vue?vue&type=template&id=c11aaed0&scoped=true"
import script from "./CorrelationSection.vue?vue&type=script&lang=js"
export * from "./CorrelationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11aaed0",
  null
  
)

export default component.exports